import { useCallback } from "react";
import { useClientPortalConfigContext } from "../context";
import { trackEvent } from "utils/analytics";

export function useAnalytics() {
    const { clientPortalConfig, clientPortalGuid } = useClientPortalConfigContext();

    const track = useCallback(
        (eventName: string, params: Record<string, unknown> = {}) => {
            trackEvent(eventName, params, { clientPortalConfig, clientPortalGuid });
        },
        [clientPortalConfig, clientPortalGuid]
    );

    return { track };
}
